import React, { useEffect, useRef } from "react";
import {
  Rocket,
  KeyRound,
  MessagesSquare,
  Puzzle,
  MonitorSmartphone,
  LayoutGrid,
} from "lucide-react";
import { FEATURES } from "../mock";

const ICONS = {
  Rocket,
  KeyRound,
  MessagesSquare,
  Puzzle,
  MonitorSmartphone,
  LayoutGrid,
};

export default function Features() {
  const ref = useRef(null);

  useEffect(() => {
    const els = ref.current.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in");
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <section id="features" className="section-pad bg-white" ref={ref}>
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="site-heading text-center max-w-[720px] mx-auto mb-16">
          <h4>Highlights</h4>
          <h2>Was uns besonders macht</h2>
          <p>
            Softwareentwicklung in wenigen Tagen – wir liefern die erste
            funktionsfähige Version extrem schnell, oft sogar innerhalb von
            48–72&nbsp;Stunden.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon] || Rocket;
            return (
              <div
                key={f.title}
                className="feature-card reveal"
                style={{ transitionDelay: `${(i % 3) * 0.1}s` }}
              >
                <div className="feature-icon">
                  <Icon size={30} />
                </div>
                <h4 className="text-lg font-semibold mb-3" style={{ color: "#141b34" }}>
                  {f.title}
                </h4>
                <p className="text-[15px] leading-relaxed text-slate-500">{f.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
